import HandWritingController from '../controllers/hand-writing'
import HandWritingLink from "../links/hand-writing";

/**
 * directiveを生成する。
 * linkClass に指定されたクラスをインスタンス化し、その link を呼び出す
 * 
 * @param {object} option 
 */
export default (option) => {
  const directive = Object.assign({
    restrict: 'E',
    replace: true,
    template: '<div class="edit-area" touch-action="none"></div>',
    scope: {},//独立スコープ
    controller: HandWritingController,
    linkClass: HandWritingLink,
  }, option || {});

  directive.link = function(scope, element, attrs, ctrl) {
    new directive.linkClass().link(scope, element, attrs, ctrl);
  }

  /**
   * directive実態定義
   */
  return function() {
    return {
      restrict: directive.restrict,
      replace: directive.replace,//<*-text-web> を↓の<div>タグで置換する
      template: directive.template,
      // template: '<div ng-include="\'modules/hand-writing/views/text.html\'"></div>',
      // templateUrl: 'modules/hand-writing/views/text.html',
      scope: directive.scope,
      link: directive.link,
      controller: ['$scope', directive.controller],
    };
  }
}